import { memo } from 'react';
import { css } from '@emotion/react';
import { Handle, Position } from '@xyflow/react';
import { CallRouteV1 } from '@frontend/api-call-route';
import { theme } from '@frontend/theme';
import { Button, Chip, Truncated } from '@frontend/design-system';
import { SharedNodeProps } from '../data';

export const BreakHourNode = memo(({ data, type, onDeleteIconClick, onEditIconClick }: SharedNodeProps) => {
  if (type !== CallRouteV1.Types.NodeType.NODE_TYPE_BREAK_HOURS) {
    throw new Error('Invalid node type for HoursTypeNode');
  }

  const handles = {
    top: { id: 'top' },
    bottom: { id: 'bottom' },
  };
  return (
    <div
      css={css`
        position: relative;
        display: inline-block;
      `}
    >
      {/* Node content */}
      <div
        css={css`
          padding: 4px 8px;
        `}
      >
        <Handle
          type='target'
          position={Position.Top}
          id={handles.top.id}
          isConnectable={true}
          style={{ visibility: 'hidden' }}
        />
        <Truncated as={Chip} maxWidth={'140px'} variant='indigo'>
          {data.label}
        </Truncated>

        <Handle
          type='source'
          position={Position.Bottom}
          id={handles.bottom.id}
          isConnectable={true}
          style={{ visibility: 'hidden' }}
        />
      </div>

      {/* Action buttons */}
      <div
        css={css`
          position: absolute;
          top: 0;
          left: 100%;
          display: flex;
          gap: 8px;
          /* Add extra spacing for the hover area around the buttons */
          padding: 4px 4px 4px 0;
        `}
        className='action-buttons'
      >
        <Button
          iconName='edit-small'
          onClick={() => onEditIconClick?.({ nodeId: data.id })}
          css={buttonStyles}
          variant='secondary'
        />
        <Button
          iconName='trash-small'
          onClick={() => onDeleteIconClick?.({ nodeId: data.id })}
          css={buttonStyles}
          variant='secondary'
        />
      </div>
    </div>
  );
});
BreakHourNode.displayName = 'BreakHourNode';

const buttonStyles = css`
  background: ${theme.colors.white};
  padding: 0;
  height: 24px;
  width: 24px;
  border: 1px solid ${theme.colors.neutral30};
  .button-icon {
    color: ${theme.colors.neutral70};
  }
`;
